import { render } from "./InstructionVideo.vue?vue&type=template&id=dbd77cc4&scoped=true"
import script from "./InstructionVideo.vue?vue&type=script&lang=js"
export * from "./InstructionVideo.vue?vue&type=script&lang=js"

import "./InstructionVideo.vue?vue&type=style&index=0&id=dbd77cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd77cc4"]])

export default __exports__